import { gql } from '@/__generated__';

export const removeLineFromCheckoutDocument = gql(/* GraphQL */ `
  mutation RemoveLineFromCheckout($orderId: String!, $lineId: String!) {
    removeLineFromCheckout(orderId: $orderId, lineId: $lineId) {
      id
    }
  }
`);

export const clearShippingAndPaymentMethodOnCheckoutOrderDocument = gql(/* GraphQL */ `
  mutation ClearShippingAndPaymentMethodOnCheckoutOrder($orderId: String!) {
    clearShippingAndPaymentMethodOnCheckoutOrder(orderId: $orderId) {
      id
    }
  }
`);

export const setShippingMethodOnCheckoutOrderDocument = gql(/* GraphQL */ `
  mutation SetShippingMethodOnCheckoutOrder(
    $orderId: String!
    $shippingMethodId: String!
    $isPersonal: Boolean
  ) {
    setShippingMethodOnCheckoutOrder(
      orderId: $orderId
      shippingMethodId: $shippingMethodId
      isPersonal: $isPersonal
    ) {
      id
    }
  }
`);

export const setPaymentMethodOnCheckoutOrderDocument = gql(/* GraphQL */ `
  mutation SetPaymentMethodOnCheckoutOrder(
    $orderId: String!
    $paymentMethodId: String!
    $isPersonal: Boolean
  ) {
    setPaymentMethodOnCheckoutOrder(
      orderId: $orderId
      paymentMethodId: $paymentMethodId
      isPersonal: $isPersonal
    ) {
      id
    }
  }
`);

export const setAddressOnCheckoutOrderDocument = gql(/* GraphQL */ `
  mutation SetAddressOnCheckoutOrder($orderId: String!, $addressId: String!) {
    setAddressOnCheckoutOrder(orderId: $orderId, addressId: $addressId) {
      id
    }
  }
`);

export const upsertAddressOnCheckoutOrderDocument = gql(/* GraphQL */ `
  mutation UpsertAddressOnCheckoutOrder(
    $orderId: String!
    $address: AddressCreateWithoutCustomerInput!
  ) {
    upsertAddressOnCheckoutOrder(orderId: $orderId, address: $address) {
      id
    }
  }
`);

export const confirmCheckoutOrderDocument = gql(/* GraphQL */ `
  mutation ConfirmCheckoutOrder($orderId: String!, $isPersonal: Boolean!) {
    confirmCheckoutOrder(orderId: $orderId, isPersonal: $isPersonal) {
      id
      status
      package
      total
    }
  }
`);

export const setNoteOnCheckoutOrderDocument = gql(/* GraphQL */ `
  mutation SetNoteOnCheckoutOrder($orderId: String!, $note: String!) {
    setNoteOnCheckoutOrder(orderId: $orderId, note: $note) {
      id
    }
  }
`);
